export const BACKEND_API_URL = window.APP_CONFIG?.BACKEND_API_URL;
// export const BACKEND_API_URL = 'https://devopspenguin.com/api/v1/';
export const BACKEND_IP_ADDRESS = window.APP_CONFIG?.BACKEND_IP_ADDRESS;
// export const BACKEND_IP_ADDRESS = 'devopspenguin.com'

